import * as angular from 'angular';
import configMaterial from './Material';

var decoratorModule = angular.module('app.areas.common.decorators', []);

decoratorModule.config(['$provide', ($provide: angular.auto.IProvideService) => {
    configMaterial($provide);
}]);

export default decoratorModule.name;
